import {
  NetworkIdState,
  NetworkIdActionTypes,
  GET_NETWORK_ID_LIST,
  GET_NETWORK_ID_LIST_FULFILLED,
  GET_NETWORK_ID_PENDING,
  GET_NETWORK_ID_FULFILLED,
  SELECT_NETWORK_ID,
  CREATE_NETWORK_ID_PENDING,
  CREATE_NETWORK_ID_FULFILLED,
  DELETE_NETWORK_ID_FULFILLED,
  SET_NETWORK_ID_LOADING,
} from './networkId.types';

export const initialState: NetworkIdState = {
  entities: [],
  selected: [],
  single: null,
  createdId: null,
  networksToSipSettings: undefined,
  ui: {
    isCreatePopupOpen: false,
    isLoading: false,
  },
};

export default function networkIdReducer(
  state = initialState,
  action: NetworkIdActionTypes,
): NetworkIdState {
  switch (action.type) {
    case GET_NETWORK_ID_LIST:
      return {
        ...state,
        selected: [],
      };

    case GET_NETWORK_ID_LIST_FULFILLED:
      return {
        ...state,
        entities: action.payload.data.data ?? [],
        selected: [],
        networksToSipSettings: action.payload.data.data ?? [],
      };

    case GET_NETWORK_ID_PENDING:
      return {
        ...state,
        single: null,
      };

    case GET_NETWORK_ID_FULFILLED:
      return {
        ...state,
        single: (action.payload.data.data ?? [])[0],
      };

    case SELECT_NETWORK_ID:
      return {
        ...state,
        selected: action.payload || [],
      };

    case CREATE_NETWORK_ID_PENDING:
      return {
        ...state,
        createdId: null,
      };

    case CREATE_NETWORK_ID_FULFILLED:
      return {
        ...state,
        createdId: action.payload.data.metadata?.idCreated ?? null,
      };

    case DELETE_NETWORK_ID_FULFILLED:
      return {
        ...state,
        selected: [],
      };

    case SET_NETWORK_ID_LOADING:
      return {
        ...state,
        single: null,
        ui: {
          ...state.ui,
          isLoading: action.payload.isLoading,
        },
      };

    default:
      return state;
  }
}
